export default __webpack_public_path__ + "6503142.png";